import classes from "./CantQuoteSalesCampaignModal.module.less";
import Modal from "~/common/components/Modal";
import { Button, Stack } from "~/common/mui";
import { CART_PAGE } from "~/utils/url/staticUrls";
import { Trans, useTranslation } from "react-i18next";

interface Props {
  onClose: () => void;
  onPlaceOrder: () => void;
  disablePlaceOrder?: boolean;
}

export const CantQuoteSalesCampaignModal = ({ onClose, onPlaceOrder, disablePlaceOrder }: Props) => {
  const { t } = useTranslation();
  return (
    <Modal
      onClose={onClose}
      footerChildren={
        <div className={classes.footer}>
          <Button variant={"text"} onClick={onClose}>
            {t("cancel")}
          </Button>
          <Stack gap={1} direction={"row"}>
            <Button color={"secondary"} href={CART_PAGE}>
              {t("feature.salesCampaign.cannotQuote.backToCart")}
            </Button>
            <Button disabled={disablePlaceOrder} onClick={onPlaceOrder}>
              {t("feature.salesCampaign.cannotQuote.placeOrder")}
            </Button>
          </Stack>
        </div>
      }
    >
      <Stack gap={1}>
        <p className={"f-bold"}>
          <Trans i18nKey={"feature.salesCampaign.cannotQuote.partOne"} />
        </p>
        <p>
          <Trans i18nKey={"feature.salesCampaign.cannotQuote.partTwo"} />
        </p>
      </Stack>
    </Modal>
  );
};
